import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AnalyticsService, CaliperService, ItemViewService } from '../../../ajs-upgraded-providers';
import { EntityType } from '../../shared/shared/entity-type.enum';
import { RlFile } from '../shared/rl-file';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  readonly file_url = '../rl/amazon/aws/s3/file/'; // + key
  readonly file_download_url = '../rl/amazon/aws/s3/downLoadfile'; // + key

  constructor(private caliperService: CaliperService, private http: HttpClient, private anlyticsService: AnalyticsService, private itemViewService: ItemViewService) { }

  getAmazonPolicy = ( uploadType: string,isCms?: boolean) => this.http.get('../rl/amazon/aws/s3/policy', { params:  { 'cmsEntry': isCms? isCms+ "" :'false', 'uploadType': uploadType ? uploadType : '' } });

  save = (file: RlFile) => this.http.post(this.file_url + file.amazonFileKey, file.amazonFileKey);

  delete = (file : RlFile) : Observable<any> => this.http.delete(this.file_url + file.amazonFileKey, {params : {
      id: file.entityId,
      type: EntityType[file.entityType],
      key: file.amazonFileKey
  }});

  getLinkTofile = (f: RlFile): Observable<Object> => this.http.post(this.file_download_url, Object.assign(f, { onWeb: true }));

  download = (f: RlFile): void => {
    this.anlyticsService.trackGoogleAnalyticsEvent('Download', f.entityId);
    //update leganto_usage for file download
    this.itemViewService.viewCitation(f.entityId, "SCID");
     const caliperReferrer = this.caliperService.getCaliperInfo(f.amazonDisplayFileName, 'DigitalResource', f.amazonDisplayFileName, 'application/pdf');
    this.caliperService.send('SCIVFT', 'citation', f.entityId, caliperReferrer);

    if ((!f.amazonFileKey) && f.url) {

      const link = document.createElement("a");
      link.href = f.url;
      link.click();
      return;
    }
    this.http.post(this.file_download_url,  Object.assign(f, { onWeb: false})).subscribe((res :{URL : any})=>  window.location =res.URL)};

  storeFile = (amazonFileKey: string): Observable<{ newFilePath: string }> => this.http.post<{ newFilePath: string }>('../rl/amazon/aws/s3/file', amazonFileKey, { 'headers': { 'Content-Type': 'application/json;charset=UTF-8' } });

}